import { DEFAULT_RESIZE_TIME } from "@angular/cdk/scrolling";

export const environment = {
  production: true,
  apiUrl: {
    // baseUrl: 'http://anandmedia.net:8086/anandmediacontrolpanel/',

    // baseUrl: 'https://anandmedia.net:8443/api/',
    baseUrl: 'https://anandmedia.net:8443/api/',
    // baseUrl: "https://api-v1.anandmedia.net/v1/",
    // baseUrl: "http://localhost:2053/api_v2_anandmedia/",

    // baseUrl: "https://test2.anandmedia.net:8443/anandmedianew/",

    //production
    baseVideoUrl: "http://anandmedia.net:8086/anandmediacms/",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts